// src/components/UserManagement.js
import React, { useState, useEffect } from 'react';
import api from '../services/api';
import {
  Box, Button, TextField, FormControl, InputLabel, Select, MenuItem,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
  CircularProgress, Alert, Snackbar, Grid, Divider // <-- THIS IS THE FIX
} from '@mui/material';

const UserManagement = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  
  // Form state
  const [username, setUsername] = useState('');
  const [fullName, setFullName] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('Finance');
  const [formError, setFormError] = useState('');
  const [snackbar, setSnackbar] = useState({ open: false, message: '' });

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const response = await api.get('/api/users');
      setUsers(response.data);
    } catch (err) {
      setError('Failed to fetch users.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormError('');
    try {
      await api.post('/api/users', { Username: username, FullName: fullName, Role: role, Password: password });
      setSnackbar({ open: true, message: `User "${username}" created successfully!` });
      // Reset form
      setUsername('');
      setFullName('');
      setPassword('');
      setRole('Finance');
      // Refresh user list
      fetchUsers();
    } catch (err) {
      setFormError(err.response?.data?.detail || 'Failed to create user.');
    }
  };

  return (
    <Box>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6} md={2}><TextField fullWidth label="Username" value={username} onChange={e => setUsername(e.target.value)} required /></Grid>
          <Grid item xs={12} sm={6} md={3}><TextField fullWidth label="Full Name" value={fullName} onChange={e => setFullName(e.target.value)} required /></Grid>
          <Grid item xs={12} sm={6} md={3}><TextField fullWidth type="password" label="Password" value={password} onChange={e => setPassword(e.target.value)} required /></Grid>
          <Grid item xs={12} sm={6} md={2}>
            <FormControl fullWidth>
              <InputLabel>Role</InputLabel>
              <Select value={role} label="Role" onChange={e => setRole(e.target.value)}>
                <MenuItem value="Finance">Finance</MenuItem>
                <MenuItem value="Onboarding">Onboarding</MenuItem>
                <MenuItem value="Attendance">Attendance</MenuItem>
                <MenuItem value="Admin">Admin</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={2}><Button type="submit" variant="contained" fullWidth sx={{ height: '56px' }}>Create User</Button></Grid>
        </Grid>
        {formError && <Alert severity="error" sx={{ mt: 2 }}>{formError}</Alert>}
      </form>
      
      <Divider sx={{ my: 3 }} />

      {loading ? <CircularProgress /> : error ? <Alert severity="error">{error}</Alert> : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Username</TableCell>
                <TableCell>Full Name</TableCell>
                <TableCell>Role</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {users.map((user) => (
                <TableRow key={user.UserID}>
                  <TableCell>{user.UserID}</TableCell>
                  <TableCell>{user.Username}</TableCell>
                  <TableCell>{user.FullName}</TableCell>
                  <TableCell>{user.Role}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={() => setSnackbar({ ...snackbar, open: false })} message={snackbar.message} />
    </Box>
  );
};

export default UserManagement;